/** @prettier */

import {format} from 'date-fns';
import {utcToZonedTime, zonedTimeToUtc} from 'date-fns-tz';

/**
 * HTML文字エスケープ
 * @param {string} 変換前文字列
 * @returns {string} 変換後文字列
 */
export function escapeStr(string: string) {
  return string
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#x27;/g, "'")
    .replace(/&#x2F;/g, '/')
    .replace(/&#x60;/g, '`');
}

/**
 * 文字列になっている数値を加算し、文字列で返す
 * @param str1 {string}
 * @param str2 {string}
 * @returns {string} str1とstr2を加算して文字列で返す
 */
export function strNumAdd(
  str1: string | undefined,
  str2: string | undefined
): string {
  return String(Number(str1) + Number(str2));
}

/**
 * タイムゾーンをAPI要求用の取得開始時刻(現地時刻の00:00)に変換する
 * @param サイト情報のタイムゾーン {string}
 * @returns アフタータイム {string}
 */
export function timezone2aftertime(timezone: string) {
  const siteTimezone = escapeStr(timezone);
  const start = format(
    utcToZonedTime(new Date(), siteTimezone),
    'yyyy-MM-dd 00:00:00'
  );
  return zonedTimeToUtc(start, siteTimezone).toISOString();
}

/**
 * API戻り値の消費電力量WをKW変換(小数点以下四捨五入)
 *
 * @param strPw {string|undefined} 消費電力量
 * @returns {number}
 */
export function convNumKw(strPw: string | undefined) {
  return strPw === undefined ? 0 : Math.round(Number(strPw) / 1000);
}
